




























import Assessment from '@/domain/assessment/entity/assessment';
import { Vue, Component, Prop } from 'vue-property-decorator';
import AssessmentResultPercentItem from './assessment-result-percent-item.component.vue';

@Component({
  components: {
    AssessmentResultPercentItem,
  },
})
class AssessmentResultPercentGraph extends Vue {
  @Prop({ required: true }) assessment!: Assessment;
}

export default AssessmentResultPercentGraph;
